export default __webpack_public_path__ + "static/logonew-f3339fbeb319d12a7e00c2bc3009d0c8.svg";